<template>
  <div
    data-intercom-target="Boolean Mode toggle"
    class="toggle-switch"
    :class="[{ 'toggle-switch--on': switchValue }, `toggle-switch--${size}`]"
    @click="toggleSwitch"
  >
    <div :class="['toggle-switch__slider', `toggle-switch__slider--${size}`]" />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["switchClicked"]);

defineProps({
  switchValue: {
    type: Boolean,
    required: true,
  },
  size: {
    type: String,
    default: "small",
    required: false,
  },
});

const toggleSwitch = () => {
  emit("switchClicked");
};
</script>

<style lang="scss" scoped>
.toggle-switch {
  @apply relative bg-accent-200 hover:bg-accent-300 rounded-full transition-all duration-200 cursor-pointer;

  &--small {
    @apply w-[24px] h-[14px] p-[1px];
  }
}

.toggle-switch--on {
  @apply bg-secondary-700 hover:bg-secondary-800;
}

.toggle-switch__slider {
  @apply absolute left-0.5 top-0.5 bg-white rounded-full shadow-toggle transition-transform ease-out duration-300 border border-white;
  transform: translateX(0);

  &--small {
    @apply w-[10px] h-[10px];
  }
}

.toggle-switch--on .toggle-switch__slider {
  transform: translateX(100%);
}
</style>
